const DEFAULT_LOCALE = 'en-US';
const INVALID_DATE_MESSAGE = 'Invalid date value';
const FORMAT_OPTIONS = {
    shortDate: { month: 'short', day: 'numeric' },
    dayLabel: { weekday: 'short', month: 'short', day: 'numeric' },
    shortDateWithYear: { month: 'short', day: 'numeric', year: 'numeric' },
    fullDateTime: {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    },
    time: { hour: 'numeric', minute: '2-digit' },
};
const DEFAULT_FORMATTERS = {
    shortDate: new Intl.DateTimeFormat(DEFAULT_LOCALE, FORMAT_OPTIONS.shortDate),
    dayLabel: new Intl.DateTimeFormat(DEFAULT_LOCALE, FORMAT_OPTIONS.dayLabel),
    shortDateWithYear: new Intl.DateTimeFormat(DEFAULT_LOCALE, FORMAT_OPTIONS.shortDateWithYear),
    fullDateTime: new Intl.DateTimeFormat(DEFAULT_LOCALE, FORMAT_OPTIONS.fullDateTime),
    time: new Intl.DateTimeFormat(DEFAULT_LOCALE, FORMAT_OPTIONS.time),
};
function validDate(input) {
    const date = input instanceof Date ? input : new Date(input);
    if (!Number.isFinite(date.getTime()))
        throw new RangeError(INVALID_DATE_MESSAGE);
    return date;
}
function present(formatName, input, context = {}) {
    const date = validDate(input);
    if (context.locale === undefined && context.timeZone === undefined) {
        return DEFAULT_FORMATTERS[formatName].format(date);
    }
    const options = {
        ...FORMAT_OPTIONS[formatName],
        ...(context.timeZone === undefined ? {} : { timeZone: context.timeZone }),
    };
    return new Intl.DateTimeFormat(context.locale ?? DEFAULT_LOCALE, options).format(date);
}
/** Format an instant as an abbreviated month and day, such as `Aug 4`. */
export function formatShortDate(input, context) {
    return present('shortDate', input, context);
}
/** Format an instant as an abbreviated weekday, month, and day, such as `Tue, Aug 4`. */
export function formatDayLabel(input, context) {
    return present('dayLabel', input, context);
}
/** Format an instant as an abbreviated month, day, and year, such as `Aug 4, 2026`. */
export function formatShortDateWithYear(input, context) {
    return present('shortDateWithYear', input, context);
}
/** Format an instant with abbreviated date parts and time, such as `Mon, May 18, 2026, 2:30 PM`. */
export function formatFullDateTime(input, context) {
    return present('fullDateTime', input, context);
}
/** Format an instant as a localized hour and minute, such as `2:30 PM`. */
export function formatTime(input, context) {
    return present('time', input, context);
}
